import React from 'react'
import { Icon } from 'labguard-cdk'

export default function EditIcon(props) {
  return <Icon icon="edit" {...props} />
}
